import axios from 'axios';
export default class PageSource {
  /**
   * Fetch all the other data from server
   * @return {Promise}
   */
  
  static fetch() {
    // If you want to go back to JSON API :¨
    const baseApi = (process.env.REACT_APP_API_URL) ? process.env.REACT_APP_API_URL : '';
    return axios
      .get(baseApi+'/wp-json/ae/v1/data')
      // .get('/api.json')
      .then((response) => {
        return Promise.resolve(response.data);
      });
  }
}
